import { FetchContext } from '../fetch-context';
import { RegionAwardSummary } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getRegionAwardSummaries: (
  fetchContext: FetchContext,
  programId: number,
  accessToken?: string,
) => Promise<RegionAwardSummary[]> = (fetchContext, programId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/region-award-summaries`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<RegionAwardSummary[]>(fetchContext.errorStore, response, 'get region award summaries'));
